import { Link } from 'react-router';
import SectionChild from '~/components/SectionChild'
import { Icon, IconName } from '~/components/ui/icon'

import { Input } from '@repo/ui/components/input'
import { Separator } from "@repo/ui/components/separator";
import { useTranslation } from 'react-i18next';
import {  MapPin, Phone } from '@repo/ui/components/icon';
import { Img } from 'openimg/react';
const social: {
  icon: IconName;
  link: string;
}[] = [
    {
      icon: "link-in",
      link: "/",
    },
    {
      icon: "face-book",
      link: "/",
    },
    {
      icon: "youtube",
      link: "/",
    },
    {
      icon: "instagram",
      link: "/",
    },
  ];
function FormFooter() {
  return (
    <form className="w-full sm:w-[342px]">
      <p className="pb-3.5">Đăng ký nhận bản tin của chúng tôi</p>
      <div className="flex h-[53px]">
        <Input
          className="h-full pl-5 rounded-r-none rounded-l-2xl min-h-[53px]"
          type="email"
          placeholder="Email của bạn"
        />
        <button
          type="submit"
          className="w-[124px] h-full min-h-[53px]
          rounded-l-none
          rounded-r-2xl
          bg-white
          text-brand-500
          font-lexend
          "
        >
          Subscribe
        </button>
      </div>
      <div className="flex items-center gap-5 mt-8">
        {/* Theo dõi
        <div className="flex gap-3 text-2xl">
          {social.map((s, i) => (
            <Link key={i} to={s.link}>
              <Icon name={s.icon} />
            </Link>
          ))}
        </div> */}
        <Link
          to="https://htsoftware.com.vn/"
          target="_blank"
          className="flex items-center gap-2"
        >
          <Img
            src="/image/logo.jpg"
            className="rounded-4xl"
            width={32}
            items-center
            gap-2
            height={32}
          />
          <p>Design by HT Software</p>
        </Link>
      </div>
    </form>
  );
}
function Footer() {
  const { t } = useTranslation("contact");
  return (
    <footer className="text-white bg-brand-500">
      <SectionChild className="py-8">
        <div className="pb-10 text-center">
          <Icon name="logo-footer" className="text-[116px]" />
        </div>
        <div className="flex flex-wrap justify-between gap-4 text-sm">
          <div className="grid gap-8">
            <div className="">
              <div className="flex flex-col gap-2.5 mt-3">
                <div className="space-y-5 max-w-[351px]">
                  <div>
                    <div className="pb-2 text-sm font-bold uppercase ">
                      {t("intro.office1.label")}
                    </div>
                    <div className="flex gap-2 mt-1">
                      <MapPin
                        size={16}
                        className="mt-0.5 min-w-4 text-[#65C9D3]"
                      />
                      <span className="text-sm">
                        {t("intro.office1.address")}
                      </span>
                    </div>
                  </div>
                  <div>
                    <div className="pb-2 font-bold uppercase">
                      {t("intro.office2.label")}
                    </div>
                    <div className="flex gap-2 mt-1">
                      <MapPin
                        size={16}
                        className="mt-0.5 className='text-sm' min-w-4 text-[#65C9D3]"
                      />
                      <span>{t("intro.office2.address")}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="pb-5">
              <div className="pb-2 text-sm font-bold uppercase">
                Đơn vị cùng hệ thống
              </div>
              <div className="flex justify-between">
                <div>
                  <Img
                    src="/image/landing_page/ft-logo-1.png"
                    width={101}
                    height={48}
                  />
                </div>
                <div>
                  <Img
                    src="/image/landing_page/ft-logo-2.png"
                    width={101}
                    height={48}
                  />
                </div>
                <div>
                  <Img
                    src="/image/landing_page/ft-logo-3.png"
                    width={101}
                    height={48}
                  />
                </div>
              </div>
            </div>

            <div className="pb-2 font-bold uppercase">
              Hotline 24/7
              {/* {t("intro.contact.label")} */}
            </div>
            <div className="flex items-center gap-2">
              <Phone size={18} className="min-w-4 text-[#65C9D3]" />
              <span className="text-[18px]">{t("intro.contact.phone")}</span>
            </div>
          </div>
          <div className="flex flex-row flex-wrap justify-between gap-5 md:flex-nowrap md:-mt-[150px] lg:mt-0">
            <FormFooter />
          </div>
        </div>
{/*
        <Separator className="my-8 bg-brand-400" />
        <div className="relative flex flex-col items-center gap-3 text-sm md:flex-row md:justify-between">
          <Link
            to="https://htsoftware.com.vn/"
            target="_blank"
            className="flex items-center gap-2"
          >
            <Img
              src="/image/logo.jpg"
              className="rounded-4xl"
              width={32}
              items-center
              gap-2
              height={32}
            />
            <p>Design by HT Software</p>
          </Link>
          <p className="text-center">
            <Link to="/" target="_blank">
              © 2025 Bản quyền thuộc về https://kland.com.vn
            </Link>
          </p>
        </div> */}
      </SectionChild>
    </footer>
  );
}

export default Footer
